import { render } from "./MessageBoardVue.vue?vue&type=template&id=450b50cc"
import script from "./MessageBoardVue.vue?vue&type=script&lang=js"
export * from "./MessageBoardVue.vue?vue&type=script&lang=js"

import "./MessageBoardVue.vue?vue&type=style&index=0&id=450b50cc&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__